module.exports = __webpack_public_path__ + "img/img_blog_05.cc4a99c6.jpg";